import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-600.css";
import { preloadCriticalFonts } from "@/lib/preloadFonts";
import App from "./App";
import "./index.css";

preloadCriticalFonts();

/** Türkçe glifler — ilk LCP’den sonra */
const loadLatinExt = () => {
  void import("@fontsource/inter/latin-ext-400.css");
};
if (typeof window.requestIdleCallback === "function") {
  window.requestIdleCallback(loadLatinExt, { timeout: 3000 });
} else {
  window.setTimeout(loadLatinExt, 2000);
}

document.getElementById("seo-prerender")?.remove();
document.getElementById("crawl-footer")?.remove();

const rootEl = document.getElementById("root")!;
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);

/** Paint shell kullanılmıyor; eski HTML’de kalmışsa temizle */
document.getElementById("ena-paint")?.remove();
window.setTimeout(() => document.getElementById("ena-paint")?.remove(), 0);
